export enum TaskFilterReminder {
  TODAY = "TODAY",
  TOMORROW = "TOMORROW",
  OVERDUE = "OVERDUE",
}
